export default __webpack_public_path__ + "static/media/title_zh_cn_pc@2x.0f2c8282.png";